import Carousel from './carousel';

class PictureTeaserInnerCarousel extends Carousel {
  constructor(selector: HTMLElement) {
    const TIME = 5000;
    const SPEED = 800;

    const el = selector instanceof HTMLElement
      ? selector
      : document.querySelector(selector);
    const carousel: HTMLElement | null | undefined = el?.closest('.m-picture-teaser');
    const pagination: HTMLElement | null | undefined = carousel?.querySelector('.o-picture-teaser-item-slider__pagination');

    super(el, {
      effect: 'slide',
      grabCursor: true,
      speed: SPEED,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      autoplay: {
        delay: TIME,
      },
      centeredSlides: true,
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      on: {
        afterInit: (swiper: any) => {
          pagination?.style.setProperty('--time', `${TIME / 1000}s`);

          if (swiper.slides.length - 2 <= 1) {
            swiper.autoplay.stop();
            swiper.unsetGrabCursor();
            swiper.params.grabCursor = false;
            swiper.params.loop = false;
          }
        },
      },
      observer: true,
      observeParents: true,
    });
  }

  init() {
    super.init();
  }
}

export default PictureTeaserInnerCarousel;
